import React from "react";
import Grid from "../Grid/Grid";
import MiniCard from "../Card/MiniCard";
import SEO from "../SEO/SEO";

function StockOverview({ data, title }) {
  return (
    <>
      <SEO
        title={title}
        keywords={title}
        description={title}
        type={title}
        url={window.location.href}
      />
      <Grid>
        {data?.map((el) => (
          <MiniCard logo={el?.logo} company={el?.name} ticker={el?.ticker} />
        ))}
      </Grid>
    </>
  );
}

export default StockOverview;
